/*
 * If the current page is not the dismissed one, stay where you are.
 * If the current page is the dismissed one.
 *   Show the next item,
 *   Unless it was the last in the list, then the previous
 *   Unless it's the only one and it is removed, then show no page (null)
 */
const pickNewSelectedId = ({ currentSelectedId, dismissedItemId, items }: {
  currentSelectedId: string | null;
  dismissedItemId: string;
  items: { id: string }[];
}): string | null => {
  if (!currentSelectedId || currentSelectedId !== dismissedItemId) {
    return currentSelectedId;
  }

  const removedItemIndex = items.findIndex(({ id }) => id === dismissedItemId);

  let newSelectedId;
  if (removedItemIndex < 0 || items.length <= 1) {
    newSelectedId = items.length > 0 ? items[0].id : null;
  } else if (removedItemIndex === items.length - 1) {
    newSelectedId = items[removedItemIndex - 1].id;
  } else {
    newSelectedId = items[removedItemIndex + 1].id;
  }

  return newSelectedId === currentSelectedId ? null : newSelectedId;
};

export default pickNewSelectedId;
